import { IonSpinner } from '@ionic/react'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/actions/Button'
import { AppContext } from '../../contexts/AppContext'
import { ModalContext } from '../../contexts/ModalContext'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'

const ServerError: React.FC = () => {
	const { retryServerConnection, networkFetching, serverErrorMessage } = useContext(AppContext)
	const { clearModals } = useContext(ModalContext)

	const { t: t } = useTranslation('pages_serverError')
	const { t: tCommon } = useTranslation('common')

	const [isLoading, setIsLoading] = useState(false)

	const handleRetry = async () => {
		setIsLoading(true)

		const startTime = Date.now()
		retryServerConnection()

		const elapsedTime = Date.now() - startTime

		if (elapsedTime < 1000) {
			await new Promise(resolve => setTimeout(resolve, 1000 - elapsedTime))
		}
		setIsLoading(false)
	}

	useEffect(() => {
		clearModals()
	}, [])

	return (
		<PublicWrapper id='server-error'>
			<h2 className='text-text-dark dark:text-white text-2xl font-semibold p-0 mb-2'>
				{t('error')}
			</h2>
			<div className='text-center text-text-dark dark:text-text-grey-100'>
				{serverErrorMessage ? serverErrorMessage : t('errorDesc0')}
			</div>
			<div className='flex flex-col gap-2 mt-4'>
				<Button className='m-0' onClick={handleRetry} disabled={isLoading || networkFetching}>
					{tCommon('yritaUudelleen')}
					{(isLoading || networkFetching) && <IonSpinner className='mx-2' />}
				</Button>
			</div>
		</PublicWrapper>
	)
}

export default ServerError
